const t = {
  name: "LaptopMigration",
  dimensions: { width: 40, height: 29 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 29" style="enable-background:new 0 0 40 29;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6,3c0-0.5,0.5-1,1-1h15c0.5,0,1,0.5,1,1v2h2V3c0-1.7-1.3-3-3-3H7C5.3,0,4,1.3,4,3v14c0,0.4,0.1,0.7,0.2,1H0
			v2h24.6l-2.3,2.3l1.4,1.4l4.7-4.7l-4.7-4.7l-1.4,1.4l2.3,2.3H7c-0.5,0-1-0.5-1-1V3z"/>
		<path class="st0" d="M17.7,6.7L15.4,9H33c1.7,0,3,1.3,3,3v14c0,0.4-0.1,0.7-0.2,1H40v2H11v-2h4.2c-0.1-0.3-0.2-0.6-0.2-1v-2h2v2
			c0,0.5,0.5,1,1,1h15c0.5,0,1-0.5,1-1V12c0-0.5-0.5-1-1-1H15.4l2.3,2.3l-1.4,1.4L11.6,10l4.7-4.7L17.7,6.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as LaptopMigration
};
